import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Redirects PDMA members with no team to /select-team. Non-PDMA (external) users have no team. */
export const teamGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasTeam() || authService.user()?.isPdmaMember === false) {
    return true;
  }
  return router.createUrlTree(['/select-team']);
};
